import { useCreateReceipt } from 'api-hooks/receipt';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import ReceiptForm from './components/form';

export type ReceiptCreateParams = null;

export default function ReceiptCreate(
  props: NavigationProps<NavigationRoutes.ReceiptsCreate>,
) {
  const { mutateAsync, error } = useCreateReceipt();

  const onResolve = useApprovalableEdit('receipts');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <ReceiptForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
